import type {GoogleMapBase} from '@Components/google-map/google-map.types';
import type {InputFieldSize} from '@Components/input-field-v2/input-field.types';

export interface GoogleMapAutocompleteProps extends GoogleMapBase {
  inputFieldSize?: InputFieldSize;
}

export const autocompleteSearchID = 'google-map-autocomplete';
